import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Upload } from "antd";
import CustomImage from "Components/CustomImage";
import React, { useEffect, useState } from "react";
import "../Pages/Dashboard/Styles/WidgetRender.css";
import { useSelector } from "react-redux";
import { getThemeColor } from "Store/reducers/Auth/AuthSlice";

function ImageUploader({
  onImageUpload,
  className,
  placeholder,
  preview,
  imagePreviewStyle,
  CardImageUploaderStyle,
}) {
  const [ProfilePicFile, setProfilePicFile] = useState(null);

  const [imagePreview, setimagePreview] = useState(null);

  const themeColor = JSON.parse(useSelector(getThemeColor));

  const setPreviewAndUpload = async (file) => {
    setimagePreview(await getBase64(file));
    onImageUpload(file, await getBase64(file));
  };

  const props = {
    name: "file",
    multiple: false,
    async onChange(info) {
      setProfilePicFile(info?.fileList?.[0]?.originFileObj);
    },
    onDrop(e) {
      setProfilePicFile(e.dataTransfer.files?.[0]?.originFileObj);
    },
    beforeUpload() {
      return false;
    },
    maxCount: 1,
    accept: "image/*",
  };

  useEffect(() => {
    if (ProfilePicFile) {
      setPreviewAndUpload(ProfilePicFile);
    } else {
      setimagePreview(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ProfilePicFile]);

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  return (
    <>
      <Upload.Dragger
        {...props}
        showUploadList={false}
        className="border-radius"
      >
        {preview || imagePreview ? (
          <CustomImage
            src={imagePreview}
            S3Key={preview}
            alt=""
            className={className}
            imagePreviewStyle={imagePreviewStyle}
          />
        ) : (
          <p
            className={`text-md w-full h-full flex flex-col items-center justify-center ${
              CardImageUploaderStyle && "card-image-uploader-style"
            }`}
            style={{ color: themeColor?.text }}
          >
            <FontAwesomeIcon icon={faUpload} />
            {placeholder}
          </p>
        )}
      </Upload.Dragger>
    </>
  );
}

export default ImageUploader;
